<template>
    <div class="table">
        <!-- table -->
        <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            :span-method="objectSpanMethod"
            :empty-text="tableText"
            :border="border"
            @selection-change="handleSelectionChange"
            @row-click="rowClick"
        >
            <!--<div v-if="isSelect">-->
            <!--<el-table-column-->
            <!--type="selection"-->
            <!--width="55">-->
            <!--</el-table-column>-->
            <!--</div>-->
            <el-table-column v-for="(item, index) in headerData" align="center" :key="index" :label="item.label" :prop="item.prop"> </el-table-column>
            <slot></slot>
        </el-table>
        <!-- pagination -->
        <div class="pagination">
            <div class="pagination-wrapper">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 25, 50, 100]"
                    :page-size="pageLength"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableCount"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            headerData: Array, // header data
            tableData: Array, // table
            tableText: String, // tips string
            tableCount: Number, // data all quantity
            border: {
                type: Boolean,
                default: false,
            },
            isSelect: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                pageLength: 10, // page length
                currentPage: 1, // current page
                multipleSelection: [], // all current select
            };
        },
        methods: {
            // change page length number
            handleSizeChange(val) {
                this.pageLength = val;
                this.reloadTablePage();
            },
            // change current page number
            handleCurrentChange(val) {
                this.currentPage = val;
                this.reloadTablePage();
            },
            // feedback reload data
            reloadTablePage() {
                this.$emit('changeTable', { pageLength: this.pageLength, currentPage: this.currentPage });
            },
            // select
            handleSelectionChange(val) {
                this.multipleSelection = val;
                if (this.multipleSelection.length === 0) {
                    this.$emit('tableSelected', this.multipleSelection);
                } else {
                    this.$emit('tableSelected', this.multipleSelection);
                }
            },
            //  获取点击的数据
            rowClick(row) {
                this.$emit('selectData', row);
            },
            // merge operating (only order)
            objectSpanMethod({ row, column, rowIndex, columnIndex }) {
                if (this.isOrder) {
                    if (columnIndex === 1 || columnIndex === 0) {
                        if (row.first) {
                            return {
                                rowspan: row.first,
                                colspan: 1,
                            };
                        } else {
                            return {
                                rowspan: 0,
                                colspan: 0,
                            };
                        }
                    }
                }
            },
        },
        components: {},
    };
</script>

<style scoped lang="stylus">
    .table
      padding 20px 20px 0 0
      .pagination
        padding-top 20px
        overflow hidden
        .pagination-wrapper
          float right
</style>
